import { Color, ShaderMaterial, VideoTexture } from "three";
import { Params } from "../../../utils/types";
import { config } from "./utils/config";
import { Uniforms } from "./utils/types";
const brushVideo = <HTMLVideoElement>document.querySelector('.brushVideo');
const bulletVideo = <HTMLVideoElement>document.querySelector('.bulletVideo');

export class Video {
    public video: HTMLVideoElement;
    public material: ShaderMaterial;
    private uniforms: Uniforms;
    private params: keyof typeof config;

    public constructor(
        urlParams: Params
    ) {
        this.params = urlParams.penType + urlParams.penNum as keyof typeof config;

        this.video = urlParams.penType == 'brush' ? brushVideo : bulletVideo;
        const videoTexture = new VideoTexture(this.video);
        videoTexture.flipY = false;

        const vertexShader =
            `
            varying vec2 vUv;
            varying vec3 Normal;
            varying vec3 Position;

            #include <common>
            #include <skinning_pars_vertex>

            void main() {
                #include <skinbase_vertex>
                #include <begin_vertex>
                #include <beginnormal_vertex>
                #include <defaultnormal_vertex>
                #include <skinning_vertex>
                #include <project_vertex>

                Normal = normalize(normalMatrix * normal);
                Position = vec3(modelViewMatrix * vec4(position, 1.0));
                float scale = 1.0/0.5;
                vUv = uv;
                gl_Position = projectionMatrix * mvPosition;
            }
            `

        const fragmentShader =
            `
            uniform sampler2D video;
            uniform float videoScale;
            uniform float videoOffset;
            uniform vec3 bgColour;
            uniform vec3 lineColour;
            varying vec2 vUv;

            void main() {
                vec2 vidvUv  =   vec2( vUv.x* 1.0, vUv.y / videoScale - videoOffset); 
                vec4 vid = texture2D(video, vidvUv);
                vec4 line = vec4(lineColour, vid.r);
                vec4 bg =  vec4(bgColour, 1.0);
                gl_FragColor = mix(bg, line, line.a);
            }
            `
        this.uniforms = {
            video: { value: videoTexture },
            videoScale: { value: config[this.params].videoScale },
            videoOffset: { value: config[this.params].videoOffset },
            bgColour: { value: new Color(0xFFFFFF) },
            lineColour: { value: new Color(config[this.params].penColour) }
        }

        this.material = new ShaderMaterial({
            uniforms: this.uniforms,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            transparent: true,
        });
    }

    public restartVideo() {
        this.video.currentTime = 0;
        this.video.pause();
    }

    public setPaperBlack() {
        this.uniforms.bgColour.value = new Color(0x000000);
    }

    public playVideo() {
        this.video.play();
    }
}